// ***********************************************************
// pathname: /v1/user-phone/info
// ***********************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/** Props */
interface SwrUserPhoneInfoProps {
  locale: string;
  successCallback?: (data?: ApiSchema<'PhoneNumberInfo'>) => void;
  errorCallback?: () => void;
}

/**
 * @description This hook is used for getting info about the user's phone number.
 * - `locale` is the language locale
 * - `successCallback` is a function that is called when the request is successful
 * - `errorCallback` is a function that is called when the request fails
 */
export const useSwrUserPhoneInfo = (props: SwrUserPhoneInfoProps) => {
  const {
    locale,
    successCallback,
    errorCallback,
  } = props;

  return useSwrMutationApi<ApiSchema<'PhoneNumberInfo'>, ApiSchema<'PhoneNumberWrite'>>({
    url: '/v1/user-phone/info',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: (data) => {
        if (successCallback) successCallback(data);
      },
      onError: () => {
        if (errorCallback) errorCallback();
      },
    },
  });
};
